import { checkEmailIsExist, checkPhoneIsExist } from '../service/register'
import { CODE_OK } from './const'
import { Loading } from 'element-ui'

// 校验邮件地址是否存在 存在报错
export let validateEmailIsExist = (rule, value, callback) => {
  if (!value) {
    callback(new Error('Invalid email format.'))
  } else {
    checkEmailIsExist({
      email: value
    }).then(res => {
      if (res.code === CODE_OK) {
        return callback(new Error('Email is existed.'))
      }
      callback()
    })
  }
}

// 校验邮件地址是否存在 不存在报错
export let validateEmailNeedExist = (rule, value, callback) => {
  if (!value) {
    callback(new Error('Invalid email format.'))
  } else {
    checkEmailIsExist({
      email: value
    }).then(res => {
      if (res.code !== CODE_OK) {
        return callback(new Error('Email does not exist.'))
      }
      callback()
    })
  }
}

// 校验邮件地址是否存在
export let validatePhoneIsExist = (rule, value, callback) => {
  if (!value) {
    callback(new Error('Invalid email format.'))
  } else {
    checkPhoneIsExist({
      phone: value
    }).then(res => {
      if (res.code === CODE_OK) {
        return callback(new Error('Phone is existed.'))
      }
      callback()
    })
  }
}

export let validatePhoneIsExist2 = (rule, value, callback) => {
  if (!value) {
    callback(new Error('Phone email format.'))
  } else {
    checkPhoneIsExist({
      phone: value
    }).then(res => {
      if (res.code !== CODE_OK) {
        return callback(new Error('Phone no existed.'))
      }
      callback()
    })
  }
}

// 校验密码
export let validatePass = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('Required.'))
  }
  if (value.length < 6) {
    return callback(
      new Error(
        'Your password is too short. Passwords must contain at least 6 characters.'
      )
    )
  }
  if (!/^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).{6,20}$/.test(value)) {
    return callback(
      new Error(
        '6-20 characters，including at least one letter and one number.'
      )
    )
  }
  callback()
}

// 校验手机号码
export let validatePhone = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('Required.'))
  }
  if (!/^[0-9]{3,20}$/.test(value)) {
    return callback(new Error('Incorrect phone number format.'))
  }
  callback()
}
